export const LOGOS = {
  BRAND: {
    LIGHT: {
      icon: "/images/logos/antos/icon.png",
      small: "/images/logos/Spark Markets.png",
      medium: "/images/logos/Spark Markets.png",
      large: "/images/logos/Spark Markets.png",
    },
    DARK: {
      icon: "/images/logos/antos/icon.png",
      small: "/images/logos/Spark Markets.png",
      medium: "/images/logos/Spark Markets.png",
      large: "/images/logos/Spark Markets.png",
    },
  },
  BROKER1: {
    LIGHT: {
      icon: "/images/logos/antos/icon.png",
      small: "/images/logos/antos/icon.png",
      medium: "/images/logos/antos/icon.png",
      large: "/images/logos/antos/icon.png",
    },
    DARK: {
      icon: "/images/logos/antos/icon.png",
      small: "/images/logos/Spark Markets.png",
      medium: "/images/logos/Spark Markets.png",
      large: "/images/logos/Spark Markets.png",
    },
  },
  BROKER2: {
    LIGHT: {
      icon: "",
      small: "",
      medium: "",
      large: "",
    },
    DARK: {
      icon: "",
      small: "",
      medium: "",
      large: "",
    },
  },
};
export const CURRENT_BROKER = "SPARK";
export const CURRENT_BROKER_NAME = "spark";
export const CURRENT_BROKER_ID = "15";
export const CURRENT_DEFAULT_SYMBOL = "ADAUSD.a";
export const CURRENT_SERVER_URL = "spark.trylevel2.com";
export const CURRENT_SERVER_NAME = "212.117.164.102:443";
export const isMT5 = true;

export const enableVideoTutorial = true;
export const BUILD_CANVAS_STRATEGY = "a7fcae56-a253-4326-89a2-87a1e2c11275";

export const BROKER_LOGO = {
  ANTOS: {
    LIGHT: {
      icon: "/images/logos/antos/icon.png",
      small: "/images/logos/antos/icon.png",
      medium: "/images/logos/antos/icon.png",
      large: "/images/logos/antos/icon.png",
    },
    DARK: {
      icon: "/images/logos/antos/icon.png",
      small: "/images/logos/antos/icon.png",
      medium: "/images/logos/antos/icon.png",
      large: "/images/logos/antos/icon.png",
    },
  },
  SPARK: {
    LIGHT: {
      icon: "/images/logos/spark/apple-touch-icon.png",
      small: "/images/logos/spark/apple-touch-icon.png",
      medium: "/images/logos/spark/apple-touch-icon.png",
      large: "/images/logos/spark/Sparkmarkets_favicon-16x16.png",
      favicon: "/images/logos/spark/Sparkmarkets_favicon-16x16.png.png",
      textLogo: "/images/logos/spark/spark_text.svg",
    },
    DARK: {
      icon: "/images/logos/spark/apple-touch-icon.png",
      small: "/images/logos/spark/apple-touch-icon.png",
      medium: "/images/logos/spark/apple-touch-icon.png",
      large: "/images/logos/spark/Sparkmarkets_favicon-16x16.png",
      favicon: "/images/logos/spark/Sparkmarkets_favicon-16x16.png.png",
      textLogo: "/images/logos/spark/spark_text.svg",
    },
  },
};
